import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import "../../../styles/components/project.scss";
import CustomCursor from "../../../components/Cursor";
import { Link } from "react-router-dom";
import Image from "../../../media/painting/16/n16-full.png";

export default function BlueDreamInACage() {
  const { t } = useTranslation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="project-focus spacing-block" style={{ paddingTop: "10vh" }}>
      <div className="content">
        <h2 className="title text-6xl">Blue Dream in a Cage</h2>
        <h3 className="year text-4xl">2022</h3>

        {/* DESCRIPTION */}
        <div className="description">
          <h4 className="text-4xl">
            {t("painting.blue_dream_in_a_cage.title")}
          </h4>
          <p className="text-2xl" style={{ textAlign: "center" }}>
            {t("painting.blue_dream_in_a_cage.text")}
          </p>
        </div>

        {/* IMAGES */}
        <div className="images">
          {/* FULL */}
          <div className="row">
            <div className="col-full">
              <img src={Image} alt="Blue Dream in a Cage" />
            </div>
          </div>
          {/* END FULL */}
        </div>
        {/* END IMAGES */}
        <Link to="/painting" style={{ color: "inherit" }}>
          <h3 className="close-text text-4xl animated-cursor">
            {t("painting.back")}
          </h3>
        </Link>
      </div>
      <CustomCursor />
    </div>
  );
}
